/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Debitornummer_Non_OptionalInputs */



/**

* @param {Debitornummer_Non_OptionalInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const debitornummer_non_optional = /** @type {((inputs?: Debitornummer_Non_OptionalInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Debitornummer_Non_OptionalInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Es muss eine Debitorennummer für die Schule festgelegt werden.")
});